/* eslint-disable */
import { React, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
// chakra imports
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../../auth-context/auth.context';

// import { Logout } from "../../../routes";
import {
  Box,
  Center,
  Flex,
  HStack,
  Stack,
  Text,
  useColorModeValue,
  Avatar,
} from '@chakra-ui/react';
import AuthApi from '../../../api/auth';

export function SidebarLinks(props) {
  const { sidebarPos, mouseOver } = props;
  const [subnav, setSubnav] = useState(null);
  const [subnavItemSelected, setSubnavItemSelected] = useState(false);

  const selectSubnavItem = () => {
    setSubnavItemSelected(true);
  };

  const showSubnav = (subNavnumber) => {
    /* !subnavItemSelected && */ setSubnav(subNavnumber);
  };
  // console.log('for subnav', subnav);

  const history = useHistory();
  const { setUser } = useAuth();
  let { user } = useAuth();
  let location = useLocation();
  let activeColor = useColorModeValue('gray.700', 'white');
  let inactiveColor = useColorModeValue(
    'secondaryGray.650',
    'secondaryGray.650'
  );
  let activeIcon = useColorModeValue('brand.500', 'white');
  let textColor = useColorModeValue('secondaryGray.650', 'white');
  let brandColor = useColorModeValue('brand.500', 'brand.400');

  const { routes } = props;
  let filteredRoutes = routes.filter((route) => route.hide !== true);
  let userDetails = null;
  try {
    const sessionUser = sessionStorage.getItem('user');
    if (sessionUser && sessionUser !== 'undefined') {
      userDetails = JSON.parse(sessionUser);
    }
  } catch (e) {
    console.error('Error parsing user from session storage', e);
  }
  if (userDetails?.user_type === 'ADMIN') {
    let routes = filteredRoutes;
    filteredRoutes = [];
    let yourRoutes = [];
    let permissions = JSON.parse(sessionStorage.getItem('permissions'));

    if (permissions && permissions.length > 0) {
      const module_names = permissions.map((d) => d.module_name);

      for (let j = 0; j < routes.length; j++) {
        if (routes[j].modules && routes[j].modules.length > 0) {
          const anyModuleExists = routes[j]?.modules?.some((module) =>
            module_names.includes(module)
          );
          if (anyModuleExists) {
            yourRoutes.push(routes[j]);
          }
        }
        if (!routes[j].modules) {
          yourRoutes.push(routes[j]);
        }
      }
    }
    filteredRoutes = yourRoutes;
  } else if (userDetails?.user_type === 'SHOWROOM') {
    const showroomAllowedNames = [
      'Maker Checkers',
      'Showroom Customer Access',
    ];
    filteredRoutes = filteredRoutes.filter((route) =>
      showroomAllowedNames.includes(route.name)
    );
  }

  // Ensure "Showroom Customer Access" is ONLY visible to SHOWROOM role
  filteredRoutes = filteredRoutes.filter(
    (route) =>
      (route.name !== 'Showroom Customer Access' &&
        route.path !== '/showroom-customer-access') ||
      userDetails?.user_type === 'SHOWROOM'
  );

  // Ensure "User Communications" is visible to SUPER_ADMIN and ADMIN role
  filteredRoutes = filteredRoutes.filter(
    (route) =>
      (route.name !== 'User Communications' &&
        route.path !== '/user-communication') ||
      userDetails?.user_type === 'SUPER_ADMIN' || userDetails?.user_type === 'ADMIN'
  );

  console.log('here are your routes', filteredRoutes, routes);
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const getCustomTabValue = (routeName) => {
    if (userDetails?.user_type === 'SHOWROOM') {
      return null;
    }
    let values;
    let valuesString = sessionStorage.getItem('notificationssummary');
    if (valuesString) {
      values = JSON.parse(valuesString);
    }

    if (values) {
      if (routeName == 'Customers') {
        return values['new_customer_last_24_hours'];
      } else if (routeName === 'Maker Checkers') {
        return values['open_maker_checker'];
      } else if (routeName === 'Customer Saving Plans') {
        return values['customer_saving_plans_users'];
      } else if (routeName === 'Advance Book') {
        return values['advance_book_gold_users'];
      } else if (routeName === 'Customer Orders') {
        return values['orders_completed_last_24_hours'];
      } else if (routeName === 'Customer Tickets') {
        return values['open_tickets'];
      }
    }

    return null;
  };


  // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
  const createLinks = (routes) => {
    return filteredRoutes.map((route, index) => {
      if (route.category) {
        return (
          <>
            <Text
              fontSize={'md'}
              color={activeColor}
              fontWeight='bold'
              mx='auto'
              ps={{
                sm: '10px',
                xl: '16px',
              }}
              pt='18px'
              pb='12px'
              key={index}
            >
              {route.name}
            </Text>
            {createLinks(route.items)}
          </>
        );
      } else if (
        route.layout === '/admin' ||
        route.layout === '/auth' ||
        route.layout === '/rtl'
      ) {
        // console.log(route.subNav ? route.subNav : 'no subnav');
        // console.log(route.path !== 'none' ? route.layout + route.path : false);
        return (
          <>
            {sidebarPos || mouseOver ? (
              <>
                <NavLink
                  key={
                    // index
                    route.path !== 'none'
                      ? route.layout + route.path
                      : route.layout + route.subNavNumber
                  }
                  to={route.path !== 'none' ? route.layout + route.path : false}
                  onClick={
                    route.subNav && subnav === route.subNavNumber
                      ? () => showSubnav(false)
                      : route.subNav
                        ? () => showSubnav(route.subNavNumber)
                        : route.subNavItem && selectSubnavItem
                  }
                >
                  {route.icon ? (
                    <Box>
                      <HStack
                        spacing={
                          activeRoute(route.path.toLowerCase())
                            ? '22px'
                            : '26px'
                        }
                        py='4px'
                        ps='10px'
                      >
                        <Flex
                          // flex-wrap='nowrap'
                          w='100%'
                          //bgColor='red'
                          alignItems='center'
                          justifyContent='center'
                        >
                          <Box
                            color={
                              activeRoute(route.path.toLowerCase())
                                ? activeIcon
                                : textColor
                            }
                            me='18px'
                          >
                            {route.icon}
                          </Box>
                          <Flex w="100%" justifyContent="space-between" alignItems="center">
                            <Text
                              whiteSpace='nowrap'
                              color={
                                activeRoute(route.path.toLowerCase())
                                  ? activeColor
                                  : textColor
                              }
                              fontWeight={
                                activeRoute(route.path.toLowerCase())
                                  ? 'bold'
                                  : 'normal'
                              }
                            >
                              {route.name}
                            </Text>
                            <span>{getCustomTabValue(route.name)}</span>
                          </Flex>
                        </Flex>
                        {route.subNav && subnav === route.subNavNumber ? (
                          <Box w='40px'>{route.iconOpened}</Box>
                        ) : route.subNav ? (
                          <Center
                            w='40px'
                            height='9'
                          // bgColor='red'
                          >
                            {route.iconClosed}
                          </Center>
                        ) : (
                          <Box
                            h='36px'
                            w='4px'
                            bg={
                              activeRoute(route.path.toLowerCase())
                                ? brandColor
                                : 'transparent'
                            }
                            borderRadius='5px'
                          />
                        )}
                      </HStack>
                    </Box>
                  ) : (
                    <Box>
                      <HStack
                        spacing={
                          activeRoute(route.path.toLowerCase())
                            ? '22px'
                            : '26px'
                        }
                        py='5px'
                        ps='10px'
                      >
                        <Text
                          me='auto'
                          color={
                            activeRoute(route.path.toLowerCase())
                              ? activeColor
                              : inactiveColor
                          }
                          fontWeight={
                            activeRoute(route.path.toLowerCase())
                              ? 'bold'
                              : 'normal'
                          }
                        >
                          {route.name}
                        </Text>
                        <Box
                          h='36px'
                          w='4px'
                          bg='brand.400'
                          borderRadius='5px'
                        />
                      </HStack>
                    </Box>
                  )}
                </NavLink>
                {route.subNav && subnav === route.subNavNumber ? (
                  <Stack direction='column' mb='auto'>
                    <Box
                      w='100%'
                      pt='6px'
                      pb='8px'
                      ps='14px'
                      bgColor='secondaryGray.100'
                    >
                      <SidebarLinks
                        routes={route.subNav}
                        sidebarPos={sidebarPos}
                        mouseOver={mouseOver}
                      />
                    </Box>
                  </Stack>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <>
                <NavLink
                  key={
                    // index
                    route.path !== 'none'
                      ? route.layout + route.path
                      : route.layout + route.subNavNumber
                  }
                  to={route.path !== 'none' ? route.layout + route.path : false}
                  onClick={
                    route.subNav && subnav === route.subNavNumber
                      ? () => showSubnav(false)
                      : route.subNav
                        ? () => showSubnav(route.subNavNumber)
                        : route.subNavItem && selectSubnavItem
                  }
                >
                  {route.icon ? (
                    <Box>
                      <HStack
                        spacing={
                          activeRoute(route.path.toLowerCase())
                            ? '22px'
                            : '26px'
                        }
                        py='5px'
                        ps='10px'
                      >
                        <Flex
                          w='100%'
                          alignItems='center'
                          justifyContent='center'
                        >
                          <Box
                            color={
                              activeRoute(route.path.toLowerCase())
                                ? activeIcon
                                : textColor
                            }
                            me='18px'
                          >
                            {route.icon}
                          </Box>
                        </Flex>
                        <Box
                          h='36px'
                          w='4px'
                          bg={
                            activeRoute(route.path.toLowerCase())
                              ? brandColor
                              : 'transparent'
                          }
                          borderRadius='5px'
                        />
                      </HStack>
                    </Box>
                  ) : (
                    <Box>
                      <HStack
                        spacing={
                          activeRoute(route.path.toLowerCase())
                            ? '22px'
                            : '26px'
                        }
                        py='5px'
                        ps='10px'
                      >
                        <Text
                          me='auto'
                          color={
                            activeRoute(route.path.toLowerCase())
                              ? activeColor
                              : inactiveColor
                          }
                          fontWeight={
                            activeRoute(route.path.toLowerCase())
                              ? 'bold'
                              : 'normal'
                          }
                        >
                          <Avatar name={route.name} bg='none' />
                        </Text>
                        <Box
                          h='36px'
                          w='4px'
                          bg='brand.400'
                          borderRadius='5px'
                        />
                      </HStack>
                    </Box>
                  )}
                </NavLink>
                {route.subNav && subnav === route.subNavNumber ? (
                  <Stack direction='column' mb='auto'>
                    <Box
                      pt='12px'
                      ps='8px'
                      bgColor='secondaryGray.100'
                      pe={{ md: '16px', '2xl': '1px' }}
                    >
                      <SidebarLinks
                        routes={route.subNav}
                        sidebarPos={sidebarPos}
                        mouseOver={mouseOver}
                      />
                    </Box>
                  </Stack>
                ) : (
                  <></>
                )}
              </>
            )}
          </>
        );
      }
    });
  };
  return (
    <>
      {createLinks(routes)}
      {/* {createLogout(Logout)} */}
    </>
  );
}

export default SidebarLinks;
